<template>
    <span>
        <b-button class="align-baseline mr-1" title="Edit" variant="default" @click="handleEditProperty">
            <font-awesome-icon :icon="['fas', 'pen-to-square']"></font-awesome-icon>
        </b-button>
        <b-button class="align-baseline" title="Delete" variant="default" v-b-modal="deleteModalId">
            <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
        </b-button>
        <modal :id="deleteModalId" title="Delete Property" @shown="onModalShown" @ok="handleDeleteProperty">
            <b-row>
                <b-col>
                    Property "{{ resortLockPropertyName }}" and all its access codes will be deleted from Lodgix.
                </b-col>
            </b-row>
            <br />
            <b-row>
                <b-col>
                    <form-select
                        label="Also delete property from LockState?"
                        v-model="values.delete_lockstate_property"
                        :options="deleteLockStateOptions"
                    ></form-select>
                </b-col>
            </b-row>
        </modal>
    </span>
</template>

<script>
import { mapGetters } from 'vuex';
import API from '../../../../api';
import Modal from '../../../generic/modal/modal.vue';
import FormSelect from '../../../generic/form-select/form-select.vue';

export default {
    components: {
        Modal,
        FormSelect,
    },
    data() {
        return {
            resortLockPropertyId: 0,
            resortLockPropertyName: '',
            deleteModalId: '',
            deleteLockStateOptions: [
                { value: false, text: 'No' },
                { value: true, text: 'Yes' },
            ],
            values: {
                delete_lockstate_property: false,
            },
        };
    },
    created() {
        this.resortLockPropertyId = this.params.data.id;
        this.resortLockPropertyName = this.params.data.name;
        this.deleteModalId = `modal-delete-resort-lock-property-${this.resortLockPropertyId}`;
    },
    methods: {
        onModalShown() {
            this.params.api.clearFocusedCell();
        },
        handleDeleteProperty() {
            this.params.delete && this.params.delete(this.params.data, this.values);
        },
        handleEditProperty() {
            this.params.update && this.params.update(this.params.data);
        },
    },
};
</script>
